import {Component} from '@angular/core';
import {ConfirmationService} from "primeng/api";
import {HttpClientService} from "../../../core/services/http-client.service";
import {ToastService} from "../../../core/services/toast.service";
import {Router} from "@angular/router";
import {CommonService} from "../../../core/services/common.service";

@Component({
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrl: './cancel-order.component.css',
  providers: [ConfirmationService]
})
export class CancelOrderComponent {
  loading = false;
  isFofo: boolean;
  offset: number = 0;
  canLoadMore: boolean = false;
  loader: boolean = false;
  notifyList: any = [];
  throttle = 0;
  scrollDistance = 3;
  orderId: string;
  itemId: string;

  // Modal visibility flags
  displayCancelModal = false;
  displayHoldModal = false;
  displayColorChangeModal = false;

  constructor(
    private httpService: HttpClientService,
    private toast: ToastService,
    private router: Router,
    private store: CommonService
  ) {
    this.isFofo = this.store.isFofo();
    this.getNotifyList();
  }

  ngOnInit(): void {}

  getNotifyList(): void {
    const obj = {
      offset: this.offset,
      limit: 10
    };
    this.canLoadMore = false;
    this.callGetNotifyList(obj);
  }

  callGetNotifyList(obj: any): void {
    if (this.loader || this.canLoadMore) {
      return;
    }
    this.loader = true;
    this.httpService.get("order/notify-orders", obj).subscribe(
      (data) => {
        this.loader = false;
        if (data['responseStatus'].toLowerCase() === 'success') {
          for (const o of data['response']) {
            this.notifyList.push(o);
          }
        } else {
          this.toast.error(data['statusMessage']);
        }
        if (data["response"].length > 0) {
          this.offset = obj.offset + obj.limit;
        } else {
          this.canLoadMore = true;
        }
      },
      (error) => {
        this.loader = false;
        if (error.statusCode === 400) {
          this.toast.error(error.response.message);
        } else {
          this.toast.error("Something went wrong");
        }
      }
    );
  }

  acceptColor(): void {
    this.displayColorChangeModal = false;
    const notify = {
      orderId: this.orderId,
      itemId: this.itemId
    };
    this.httpService.postWithParams("order/notify-color-change", notify).subscribe(
      (data) => {
        if (data['responseStatus'].toLowerCase() === 'success') {
          this.router.navigate(['/pages/home/orderDetails']);
          this.toast.success("Color changed successfully");
        } else {
          this.toast.error(data['statusMessage']);
        }
      },
      (error) => {
        if (error.statusCode === 400) {
          this.toast.error(error.response.message);
        } else {
          this.toast.error("Something went wrong");
        }
      }
    );
  }

  openModal(modalType: string, orderId: string, itemId?: string): void {
    this.orderId = orderId;
    this.itemId = itemId;
    if (modalType === 'cancel') {
      this.displayCancelModal = true;
    } else if (modalType === 'hold') {
      this.displayHoldModal = true;
    } else if (modalType === 'colorChange') {
      this.displayColorChangeModal = true;
    }
  }

  cancelOrder(): void {
    this.displayCancelModal = false;
    this.loader = true;
    this.httpService.postWithParams("cancelOrder?orderId=" + this.orderId).subscribe(
      (data) => {
        this.loader = false;
        if (data['responseStatus'].toLowerCase() === 'success') {
          this.toast.success("Order cancelled successfully");
          this.router.navigate(['/pages/home/myWallet']);
        } else {
          this.toast.error(data['statusMessage']);
        }
      },
      (error) => {
        this.loader = false;
        if (error.statusCode === 400) {
          this.toast.error(error.response.message);
        } else {
          this.toast.error("Something went wrong");
        }
      }
    );
  }

  holdOrder(): void {
    this.displayHoldModal = false;
    this.loader = true;
    this.httpService.postWithParams("hold-notify-order?orderId=" + this.orderId).subscribe(
      (data) => {
        this.loader = false;
        if (data['responseStatus'].toLowerCase() === 'success') {
          this.toast.success("Order held successfully");
          this.router.navigate(['/pages/home/dashboard']);
        } else {
          this.toast.error(data['statusMessage']);
        }
      },
      (error) => {
        this.loader = false;
        if (error.statusCode === 400) {
          this.toast.error(error.response.message);
        } else {
          this.toast.error("Something went wrong");
        }
      }
    );
  }
}
